export default __webpack_public_path__ + "static/media/Move_Handle.ca559cfb.svg";